import { Component, OnInit } from "@angular/core";
import { DownloadService } from "src/app/services/download.service";
import { OrderManagementService } from "src/app/services/orderManagement.service";
import { saveAs } from "file-saver";

export interface orderFrame {
  dateFrom?: Date;
  dateTo?: Date;
  page: number;
}

@Component({
  selector: "app-invoice-management",
  templateUrl: "./invoice-management.component.html",
  styleUrls: ["./invoice-management.component.scss"],
})
export class InvoiceManagementComponent implements OnInit {
  invoices = [];
  isLoading = false;
  data: any;
  settingInvoice: any;

  orderFrame: orderFrame = {
    dateFrom: null,
    dateTo: null,
    page: 1,
  };

  constructor(
    private orderManagementService: OrderManagementService,
    private downloadService: DownloadService
  ) {}

  ngOnInit(): void {
    this.paginate(this.orderFrame);
    this.settingInvoice = {
      is_active_generate: null,
      template: null,
      next_number: null,
    };
  }

  onFilter() {
    this.orderFrame.page = 1;
    this.paginate(this.orderFrame);
  }

  paginate(orderFrame: orderFrame) {
    this.isLoading = true;
    this.orderManagementService.getInvoices(orderFrame).subscribe(
      (req) => {
        this.data = req.data;
        this.invoices = req.data.data;
        this.isLoading = false;
      },
      () => (this.isLoading = false)
    );
  }

  downloadInvoice(invoice) {
    this.downloadService.downloadInvoiceAdmin(invoice).subscribe((data) => {
      saveAs(data, "invoice-no-" + invoice.invoice_number + ".pdf");
    });
  }

  onPaginate(ev) {
    this.orderFrame.page = ev.page + 1;
    this.paginate(this.orderFrame);
  }

  getSettings() {
    this.orderManagementService.getSettingsInvoice().subscribe((req) => {
      this.settingInvoice = req.data;
    });
  }

  onEditSettings() {
    this.orderManagementService
      .editSettingsInvoice(this.settingInvoice)
      .subscribe((req) => {
        this.settingInvoice = req.data;
        this.isOpenSetting = false;
      });
  }

  public isOpenSetting = false;
  public openSettings() {
    this.getSettings();
    this.isOpenSetting = true;
  }
}
